export const FETCHING = 'FETCHING';
export const FETCHED = 'FETCHED';
export const IDLE = 'IDLE';
export const FAILED = 'FAILED';
export const ERROR = 'ERROR';
export const SENDING = 'SENDING';
export const SENT = 'SENT';
export const READY = 'READY';